import { render } from "./ArticleHashtagInput.vue.js?vue&type=template&id=b822c4ce!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleHashtagInput.vue?vue&type=template&id=b822c4ce"
import script from "./ArticleHashtagInput.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleHashtagInput.vue?vue&type=script&lang=js"
export * from "./ArticleHashtagInput.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleHashtagInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/edit-article-page/elements/ArticleHashtagInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b822c4ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b822c4ce', __exports__)) {
    api.reload('b822c4ce', __exports__)
  }
  
  module.hot.accept("./ArticleHashtagInput.vue.js?vue&type=template&id=b822c4ce!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ArticleHashtagInput.vue?vue&type=template&id=b822c4ce", () => {
    api.rerender('b822c4ce', render)
  })

}


export default __exports__